// Module
var code = "<svg view=\"Icon\" data-name=\"[[ tag.active ? 'icon-checkbox-checked' : 'icon-checkbox-default' ]]\"></svg> ";
// Exports
export default code;